import { DobYear, DobMonth, DobDay } from "../../../../Constants/Constants";
import SelectBox from "../../../UI/SelectBox";
import { useFormContext } from "react-hook-form";
import ErrorMessage from "./ErrorMessage";

const DateOfBirth = ({ notDobValid }) => {
  const { register, errors } = useFormContext();

  const removeClass = () => {
    document.getElementById("DobDay").classList.remove("pulse2");
    document.getElementById("DobDay").classList.remove("shadow2");
  };
  return (
    <div className="date-birth" id="date-birth">
      <fieldset className="scheduler-border p-2 px-2">
        <legend className="scheduler-border dobs px-2 m-0">
          Date Of Birth
        </legend>
        
        <div className="row col-12" style={{ marginLeft: '1px' }}>
          <div className="  mb-2 col-4   ">
            <SelectBox
              className="form-control dob select-style"
              OptionValue={DobDay}
              name="DobDay"
              onChange={removeClass}
              id="DobDay"
              myRef={register({
                required: "Please select date",
              })}
              validationMsg={errors?.DobDay && errors?.DobDay?.message}
            />
            <i className="tick fa" style={{ display: "none" }}></i>
          </div>
          <div className="  mb-2 col-4   ps-lg-0">
            <SelectBox
              className="form-control dob select-style"
              OptionValue={DobMonth}
              name="DobMonth"
              id="DobMonth"
              myRef={register({
                required: "Please select month",
              })}
              validationMsg={errors?.DobMonth && errors?.DobMonth?.message}
            />
            <i className="tick fa" style={{ display: "none" }}></i>
          </div>
          <div className="  mb-2 col-4    ps-lg-0">
            <SelectBox
              className="form-control dob select-style"
              OptionValue={DobYear}
              name="DobYear"
              id="DobYear"
              myRef={register({
                required: "Please select year",
              })}
              validationMsg={errors?.DobYear && errors?.DobYear?.message}
            />
            <i className="tick fa" style={{ display: "none" }}></i>
          </div>
          {notDobValid && <ErrorMessage errMessage='Invalid date of birth provided.' />}
        </div>
      </fieldset>
    </div>
  );
};

export default DateOfBirth;
